import update from 'immutability-helper';
import {
    SET_LICENSES_PAGINATED_LIST,
    LICENSE_SAVED_ADD_TO_LIST,
    LICENSE_DELETED,
    LICENSE_MOVED
} from '../../actions/types'

export default function license(state = {
    list: {
        total: 0,
        per_page: 15,
        on_page: 1,
        records: [

        ]
    }
}, action = {}) {
    switch(action.type) {
        case SET_LICENSES_PAGINATED_LIST:
            return update(state, {
                list: {$set: action.payload}
            });

        case LICENSE_SAVED_ADD_TO_LIST:
            const {index, model} = action.payload;
            if (index > -1) {
                return update(state, {
                    list: {
                        records: {
                            [index]: {
                                $set: model
                            }
                        }
                    }
                })
            } else {
                return update(state, {
                    list: {
                        records: {
                            $unshift: [model]
                        }
                    }
                })
            }

        case LICENSE_DELETED:
            return update(state, {
                list: {
                    records: {
                        $splice: [[action.payload,1]]
                    }
                }
            })

        case LICENSE_MOVED:
            return update(state, {
                list: {
                    records: {
                        [action.payload.index]: {
                            locations: {
                                $set: action.payload.data
                            }
                        }
                    }
                }
            })

        default: return state;
    }
}